export const List = ({features, classes}) => {
    return (
        <ul className={`${classes}`}>
            {features.map((feature, index) => (
                <li key={index}>{feature}</li>
            ))}
        </ul>

    )
}
